import { ClearRounded, EditRounded } from "@mui/icons-material";
import { Avatar, Box, Button, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Alert, Table } from "../../layout";
import * as actions from "../../api/actions/pos";
import { useEffect } from "react";
import { endpoints } from "../../api/actions/api";
import { useContext } from "react";
import { AppContext } from "../../App";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";
import { action, controller, Server } from "../../api/Server";
import { no_img } from "../../assets";

const Stores = (props) => {
  const { _delete, _store } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setLoader, setPageTitle, authUser } = useContext(AppContext);
  const [csvHeader, setCsvHeader] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [access, setAccess] = useState({});

  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    if (authUser && authUser.featuresAccess && authUser.featuresAccess.store)
      setAccess({ ...authUser.featuresAccess.store });
    return () => {};
  }, [authUser]);

  useEffect(() => {
    setPageTitle(t("stores"));

    if (authUser && authUser.id) {
      setLoader(true);
      Server(controller.Store + action.GetAllByOrg).get((res) => {
        res && res.status === 200 && setTblData(res.result);
        setLoader(false);
      });
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const handleAddEdit = (val) => {
    navigate(`store-form/${val.id || ""}`);
  };

  const handleDlt = (id) => {
    if (_store.id === id) {
      setAlert({
        isOpen: true,
        type: "warning",
        title: t("switchToAnotherStore"),
        subTitle: t("storeDltWarning"),
      });
    } else {
      setAlert({
        isOpen: true,
        type: "confirmation",
        title: t("itsTooDangerous"),
        subTitle: t("storeDltTitle"),
        onConfirm: () => {
          const onComplete = (res) => {
            if (res.status === 200) {
              setAlert({
                isOpen: true,
                type: "success",
                title: t("dltSuccessTitle"),
                subTitle: res.msg,
              });
              setTblData((x) => [...x.filter((j) => j.id !== res.result.id)]);
            } else {
              setAlert({
                isOpen: true,
                type: "error",
                title: t("error"),
                subTitle: res.msg,
              });
            }
          };
          _delete(endpoints.Store, id, actions.ActionType.RmvStore, onComplete);
        },
      });
    }
  };

  useEffect(() => {
    setCsvHeader([
      { key: "storeName", label: t("storeName") },
      { key: "fullName", label: t("managerName") },
      { key: "address", label: t("address") },
      { key: "city", label: t("city") },
      { key: "state", label: t("state") },
      { key: "zip", label: t("ZIP") },
      { key: "phone", label: t("phone") },
    ]);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ActionComp = (props) => (
    <div className="bs-secondary br-8 w-fit">
      {access.isHaveEditAccess && (
        <Tooltip arrow title={t("edit")}>
          <IconButton
            onClick={() => handleAddEdit(props)}
            size="small"
            color="primary"
            className="mr-5 p-5"
          >
            <EditRounded className="fs-18 m-2" />
          </IconButton>
        </Tooltip>
      )}
      {access.isHaveDeleteAccess && (
        <Tooltip arrow title={t("delete")}>
          <IconButton
            onClick={() => handleDlt(props.id)}
            size="small"
            color="error"
            className="mr-5 p-5"
          >
            <ClearRounded className="fs-18 m-2" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );

  const HeaderComp = () => (
    <div className="d-flex flex-wrap g-5">
      {access.isHaveAddAccess && (
        <Button
          onClick={handleAddEdit}
          sx={{
            width: { md: "180px", xs: "100%" },
            mb: { xs: "10px", md: "0px" },
            fontSize: "17px",
            padding: "8px",
          }}
        >
          {t("addStore")}
        </Button>
      )}

      {access.isHaveExportAccess && (
        <Box
          className="d-flex"
          sx={{
            width: { xs: "100%", md: "auto" },
          }}
        >
          <CSVLink
            data={tblData}
            headers={csvHeader}
            filename={`${t("store")} (${new Date().toDateString()}).csv`}
            target="_blank"
            className="d-flex a-center j-center p-15 fs-16 fw-5 tx-upp primary-color bg-primarySM br-15"
          >
            {t("exportCSV")}
          </CSVLink>
        </Box>
      )}
    </div>
  );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "actions", label: t("actions") },
          { id: "store", label: t("store") },
          { id: "manager", label: t("manager") },
          { id: "address", label: t("address") },
        ]}
        tblData={tblData.map((val) => {
          return {
            ...val,
            store: (
              <div className="d-flex g-15">
                <Avatar
                  src={val.logo ? val.logo : no_img}
                  alt="Product"
                  variant="rounded"
                  sx={{ width: 40, height: 40 }}
                />
                <div className="d-grid">
                  <span className="fw-5">
                    {val.storeName}{" "}
                    {val.storeLocalName && (
                      <>
                        {" | "} {val.storeLocalName}
                      </>
                    )}
                  </span>
                  <span className="fs-12 gap-5">
                    <span className="fw-5">
                      {t("id")}: {val.id}&nbsp;
                    </span>
                    | &nbsp;<span className="fw-5">{val.email}</span> &nbsp;
                    {val.phone && (
                      <>
                        | &nbsp;<span className="fw-5">{val.phone}</span>
                      </>
                    )}
                  </span>
                </div>
              </div>
            ),
            manager: (
              <div className="d-grid">
                <span className="fw-5">{val.fullName}</span>
                <span className="fw-5 fs-12">{val.mngPhone}</span>
              </div>
            ),
            address: (
              <div className="d-grid fs-14">
                <span>
                  {val.city} {val.city && ", "} {val.state} {val.zip}
                </span>
                <span>{val.address}</span>
              </div>
            ),
          };
        })}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

const mapStateToProps = (state) => ({
  _stores: state.pos.stores,
  _type: state.pos.type,
  _store: state.pos.defStore,
});

const mapActionToProps = {
  _get: actions.get,
  _delete: actions.Delete,
  _clear: actions.clear,
};

export default connect(mapStateToProps, mapActionToProps)(Stores);
